import Vue from 'vue';
import { Route } from 'vue-router';
import Vuex, {
    Plugin,
    Store,
} from 'vuex';

import {
    initializeBackgroundJobs,
    subscribeToUser as backgroundJobsSubscription,
} from '@app/schedule/backgroundJobs';
import { basicLogger } from '@store/logging/basicLogger';
import data, {
    IDataState,
    moduleNamespaces as dataModuleNamespaces,
} from '@store/modules/data/dataIndex';
import persistSportBetSlip from '@store/persistence/sportBetSlipPersist';
import persistState from '@store/persistence/statePersist';

import errors from './modules/errors/errorIndex';
import {
    navigationModule,
    INavigationState,
    subscriptions as navigationSubscriptions,
} from './modules/navigation';
import UI, { IUiState } from './modules/ui/uiIndex';

Vue.use(Vuex);

Object.keys(dataModuleNamespaces).forEach((key) => {
    dataModuleNamespaces[key].unshift('data');
});

export interface IState {
    navigation: INavigationState;
    data: IDataState;
    ui: IUiState;
    route: Route;
    errors: any;
}

type SbStatePlugin = Plugin<IState> | ReturnType<Plugin<IState>>;

const plugins: SbStatePlugin[] = [
    persistState,
    persistSportBetSlip,
];

if (process.env.NODE_ENV === 'development') {
    plugins.push(basicLogger);
}

const store = new Store({
    modules: {
        errors,
        data,
        navigation: navigationModule,
        ui: UI,
        route: {},
    },
    plugins,
});

initializeBackgroundJobs(store);

export const initializeSubscriptions = () => {
    navigationSubscriptions(store);
    backgroundJobsSubscription(store);
};

export default store;
